import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const GamesView = lazy(() => import("."));
const GameView = lazy(() => import("./game"));
const ChessAIGame = lazy(() => import("./chess-ai-game"));
const MinesweeperSolo = lazy(() => import("./minesweeper-solo"));

export default [
  { index: true, Component: GamesView },
  { path: "ai/chess", Component: ChessAIGame },
  { path: "minesweeper/solo", Component: MinesweeperSolo },
  { path: ":gameRef", Component: GameView },
] satisfies RouteObject[];
